<template>
    <v-layout class="mb-4 py-3 px-4 training-management__flying-panel" align-center justify-center
              wrap
    >
        <div :class="{'mr-3': $vuetify.breakpoint.smAndUp, 'mb-3': $vuetify.breakpoint.smAndDown}">Выбрано {{ quantity }} элемент</div>
        <buttonRed class="training-management__cancel-btn" :class="{'mr-4': $vuetify.breakpoint.mdAndUp}" @click.native="cancel">{{ $t("Отменить обучение") }}</buttonRed>
        <v-btn class="training-management__close-btn" :class="{'mb-4': $vuetify.breakpoint.smAndDown}" icon>
            <v-icon @click.native="close">
                mdi-close
            </v-icon>
        </v-btn>
    </v-layout>
</template>
<script lang="ts">
import Vue from 'vue';
import buttonRed from '@/components/ui/buttons/button_red.vue';

export default Vue.extend({
  components: {buttonRed},
  props     : {
    quantity: {
      type: Number,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    close() {
      this.$emit('close');
    },
  },
});
</script>

